import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import useAppModernisation from "../../hooks/useAppModernisation";
import GuidelinesGrid from "../shared/GuidelinesGrid";
import styles from "./GuidelinesMenuModal.module.scss";

const GuidelinesMenuModal = ({ isOpen, onClose }) => {
  const location = useLocation();
  const previousLocationRef = useRef(location.pathname);
  const appModernisation = useAppModernisation();
  const { isWebModernisationEnabled } = appModernisation || {};

  // Set CSS variable for AppSidebar width when modal opens
  useEffect(() => {
    if (isOpen) {
      const appSidebar = document.querySelector('[class*="appSidebar"]');
      if (appSidebar) {
        const appSidebarWidth = appSidebar.offsetWidth;
        document.documentElement.style.setProperty("--app-sidebar-width", `${appSidebarWidth}px`);
      }
    } else {
      // Clean up CSS variable when modal closes
      document.documentElement.style.removeProperty("--app-sidebar-width");
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && location.pathname !== previousLocationRef.current) {
      onClose();
    }
    previousLocationRef.current = location.pathname;
  }, [location.pathname, isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const modalContent = (
    <div
      className={`${styles.modalOverlay} ${isWebModernisationEnabled ? "modernisation-enabled" : ""}`}
      onClick={handleOverlayClick}
    >
      <div className={styles.guidelinesContainer}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            <i className="tg-icons-Guidelines"></i>
            Guidelines
          </h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close guidelines menu"
          >
            <i className="tg-icons-Cross"></i>
          </button>
        </div>

        <div className={styles.modalContent}>
          <GuidelinesGrid variant="modal" showCloseButton={false} />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

GuidelinesMenuModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default GuidelinesMenuModal;
